var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.editing
      ? _c("div", { staticClass: "level" }, [
          _c(
            "div",
            { staticClass: "level-left" },
            [
              _c(
                "button",
                {
                  staticClass: "level-item button is-text",
                  attrs: { "data-test": "set-name" },
                  on: {
                    click: function ($event) {
                      return _vm.setEdit(true)
                    },
                  },
                },
                [
                  _c("dc-icon", { attrs: { icon: "pencil" } }),
                  _vm.title
                    ? _c("span", { attrs: { "data-test": "token-name" } }, [
                        _vm._v(_vm._s(_vm.title)),
                      ])
                    : _c("span", { attrs: { "data-test": "token-name" } }, [
                        _vm._v("Set name"),
                      ]),
                ],
                1
              ),
              _c("transition", { attrs: { name: "fade" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.success,
                        expression: "success",
                      },
                    ],
                    staticClass: "level-item has-text-success",
                    attrs: { "data-test": "token-update-success" },
                  },
                  [_vm._v(" Token name updated successfully ")]
                ),
              ]),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm.editing
      ? _c(
          "form",
          {
            staticClass: "field is-grouped",
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.submit.apply(null, arguments)
              },
            },
          },
          [
            _c("p", { staticClass: "control is-expanded" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.$v.apikey.name.$model,
                    expression: "$v.apikey.name.$model",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "input",
                attrs: { type: "text", "data-test": "token-name-input" },
                domProps: { value: _vm.$v.apikey.name.$model },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.$v.apikey.name,
                      "$model",
                      $event.target.value.trim()
                    )
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
            ]),
            _c("p", { staticClass: "control" }, [
              _c(
                "button",
                {
                  staticClass: "button is-success",
                  class: { "is-loading": _vm.fetching },
                  attrs: {
                    disabled: _vm.isValid,
                    "data-test": "token-name-save",
                  },
                },
                [_vm._v(" Save ")]
              ),
            ]),
            _c("p", { staticClass: "control" }, [
              _c(
                "a",
                {
                  staticClass: "button",
                  attrs: { "data-test": "token-name-cancel" },
                  on: { click: _vm.cancelEdit },
                },
                [_vm._v(" Cancel ")]
              ),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }